module.exports = __webpack_public_path__ + "img/member-icon.9dbe8777.png";